export default __webpack_public_path__ + "static/media/adopcion.e802aeef.bin";